"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultLocale = exports.defaultCurrency = exports.SUPPORT_LINK = exports.BANK_LINK = void 0;
var defaultLocale = 'en-US';
exports.defaultLocale = defaultLocale;
var defaultCurrency = 'USD';
exports.defaultCurrency = defaultCurrency;
var BANK_LINK = {
  alt: 'secure-connection',
  secure: 'Secure',
  encrypted: 'Your information is encrypted end-to-end using bank-level 256-bit encryption',
  "private": 'Private',
  credentials: 'Your credentials will never be made accessible to EarnUp',
  connectMyBankAccount: 'Connect my bank account',
  manuallyEnterBank: 'Manually enter bank',
  enterBankInfo: 'Enter Bank Account',
  pleaseProvideInfo: 'Please provide the following information to link your bank account. We recommend using a checking account.',
  selectAccountType: 'Account type',
  checking: 'Checking',
  savings: 'Savings',
  giactConnectBank: 'Connect',
  giactCancel: 'Cancel'
};
exports.BANK_LINK = BANK_LINK;
var SUPPORT_LINK = {
  text: 'If you continue to receive this error, please submit a support request at ',
  link: 'support.earnup.com'
};
exports.SUPPORT_LINK = SUPPORT_LINK;